import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Add an interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if the error is a 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized: Redirecting to login.");
      localStorage.removeItem("current-user");
      const navigate = useNavigate();
      navigate("/login");
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
